import http from "@/http-common";
/**
 * Clase espejo de los endpoint de Review
 */
class Review {
  getReviews(filterParams) {
    return http.get("reviews/", { params: filterParams });
  }
  postReview(local_review) {
    return http.post("reviews/", local_review);
  }
  putReview(id_local_review, local_review) {
    return http.put("reviews/" + id_local_review, local_review);
  }
  deleteReview(idReview) {
    return http.delete("reviews/" + idReview);
  }
}
export default new Review();
